import type { GridRow } from 'modules/campaign/plan/types';
import type { Supplier } from 'modules/supplier/supplier/types';

/**
 * Whether the row currently carries values that could survive a supplier
 * change to `supplier`. Used by EditSupplier and supplier clipboard paste to
 * decide whether to offer "Keep values?" (`_reset: false` vs `_reset: true`).
 */
export function checkHasValue(row: GridRow, supplier: Supplier | null): boolean {
  if (!supplier) {
    return false;
  }

  // # 1154, We can only keep values for same direction
  if (row.kind === 'SMART') {
    if (row.direction === supplier.product.direction && (row.rate.client || row.rate.provider)) {
      return true;
    }
    return false;
  }
  // @TODO specialization fields, should be on strategy?
  return (['gross_price', 'client_price', 'provider_price'] as const).some(
    (field) => row.config[field] && !row.config[field].empty,
  );
}
